import { Component, ViewEncapsulation } from '@angular/core';

@Component({
  selector: 'sham-i-plus-03',
  standalone: true,
  templateUrl: '../../assets/plus-03.svg',
  encapsulation: ViewEncapsulation.None
})
export class ShamPlus03Icon {}
